export const submenu = {
  backgroundColor: 'var(--primary-color)',
  marginLeft: 20,
  marginRight: 20,
} as React.CSSProperties;

export const lastSubmenu = {
  backgroundColor: 'var(--primary-color)',
  marginLeft: 20,
  marginRight: 20,
  marginBottom: 5,
} as React.CSSProperties;
